import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import UserStorageUtil from '../../util/UserStorageUtil';
import HmAjax from '../../util/HmAjax';
import $ from 'jquery';
import HmEventRegistry from '../../model/HmEventRegistry';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import Errmsg from './Errmsg';

export default class LessonView extends LoggedInPage{
	
	constructor(props) {
		super(props);
		this.state = { "dataLoaded": false, data: {}, lessonUrl:null, iFrameHeight: '0px', AlertModalShow:false}
		this.requestParams = "";
		this.trackId = null;		
		this.trackLessonClose = this.trackLessonClose.bind(this);
		this.trackLessonCloseInICEPIE = this.trackLessonCloseInICEPIE.bind(this);
		this.handleMessage = this.handleMessage.bind(this);
		this.setContentSize = this.setContentSize.bind(this);
		this.resizeCall = this.resizeCall.bind(this);		
		this.userId = null;
		
		this.enableTimer = true;
		this.enableSessionTimer = true;
		this.previousEventObj = {};
		this.icepieTrackingTimer = false;
		this.icepieActivityTrackingTimer = true;
		this.currentDD = 0;
		this.pulseInteractivityId = null;
		this.interativeType = null;
		this.lessonViewStopped = false;

		this.substituteZAProxy = this.substituteZAProxy.bind(this);
		
		this.hideAlertModal = this.hideAlertModal.bind(this);
		this.errorMsg={
			heading:'',
			srcval:'',
			description:''
		}
	}

	substituteZAProxy(){
		let lessonUrl = this.state.lessonUrl;

		if(lessonUrl && lessonUrl.length > 0){
			lessonUrl = lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));			
		}

		return lessonUrl;
	}

	componentDidMount() {
		this.setState({ loggedIn: true});
		this.getLessonUrl();
		
		var me =  this;
		
		this.initiateICEPIETimer();
		this.initiateICEPIEActivityTimer();
		this.initiateSessionTimer();

		var myConfObj = {
		  iframeMouseOver : false
		}
		
		$(window).on('beforeunload', function() {			
			me.trackLessonClose();
			me.trackLessonCloseInICEPIE();
		});
		$(window).on('unload', function() {
			me.trackLessonClose();	
			me.trackLessonCloseInICEPIE();
		});		
		
		this.userId = this.getUser().getUserId();
		
		window.addEventListener('message', this.handleMessage, false);
		
		$(window).resize(function(){
			me.setContentSize();
		});
		
		this.setContentSize();
	}	
	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.trackLessonClose);
		window.removeEventListener('message', this.handleMessage, false);
	}
	SessionCheck(){			
		var me = this;
		var user_Success = function(userObj){			
			if(typeof userObj === "object" && userObj.authToken){
				//login success
				
			}else{
				me.enableSessionTimer = false;
				HmEventRegistry.fireEvent("LOG_OUT_PROMPT_EXIT");
			}
		}

		var user_Failure = function(error){
			//login failure	
			me.enableSessionTimer = false;
			HmEventRegistry.fireEvent("LOG_OUT_PROMPT_EXIT");
		}		
		
		me.sessionCheck(user_Success,user_Failure);
	} 
	handleMessage(event){	
	  console.log("handlemessage name=="+event.data);
	  var me = this;
	  var trackobj = {};
	  var params = this.getAllParamsObj();
	  var msgData = event.data[0] === '{' ? JSON.parse(event.data) : "";
	  var handleMsgName = msgData.name;
	  var handleMsgData = msgData.params;
	  trackobj.lesson_id = parseInt(params.lessonidTracking);
	  trackobj.interactivity_id = null;
	  this.enableSessionTimer = true;
	 
	  if(typeof msgData === "object"){
		  //console.log(JSON.parse(event.data));
		  if(handleMsgName != "html5UserAction"){
			  return false;
		  }
		  me.currentDD = handleMsgData.ddNo;	  
		  me.lessonViewStopped |= ["pause", "end"].indexOf(handleMsgData.action) > -1;
		  trackobj.lesson_dd = handleMsgData.ddNo;
		  trackobj.type = me.getTracker().enums.lessonElementType[handleMsgData.type.toLowerCase()];
		  me.interativeType = me.getTracker().enums.lessonElementType[handleMsgData.type.toLowerCase()];
		  
		  if(["play","initPlay"].indexOf(handleMsgData.action) > -1){
			  me.lessonViewStopped = false;
			  trackobj.resumed = handleMsgData.action === "play";
			  trackobj.dd_url = handleMsgData.ddUrl;
			  me.trackLessonInICEPIE(trackobj, "lesson_element_started");
			  me.icepieTrackingTimer = true;
		  }
		  else if(handleMsgData.action == "pause"){
			  me.trackLessonPause(trackobj);
		  }
		  else if(handleMsgData.action == "close" && !me.lessonViewStopped){
			  me.trackLessonPause(trackobj);
		  }
		  else if(handleMsgData.action == "markerOpen" &&  me.previousEventObj.action != "pause"){
			  trackobj.interactivity_id = null;
			  me.pulseInteractivityId = handleMsgData.markerNo;
			  me.trackLessonPause(trackobj);
			  trackobj.interactivity_id = handleMsgData.markerNo;
			  trackobj.resumed = false;
			  trackobj.dd_url = handleMsgData.ddUrl;
			  me.trackLessonInICEPIE(trackobj, "lesson_element_started");
		  }
		  else if(handleMsgData.action == "markerClose") {
			  trackobj.interactivity_id = me.previousEventObj.markerNo;
			  me.trackLessonInICEPIE(trackobj, "lesson_element_ended");				  
		  }
		  else if(handleMsgData.action == "end") {
			  me.trackLessonInICEPIE(trackobj, "lesson_element_ended");	
			  me.icepieTrackingTimer = false;
		  }
		  else if(handleMsgData.action == "open" && handleMsgData.type == "act") {
			  me.lessonViewStopped = false;
			  me.icepieTrackingTimer = false;			  
			  trackobj.resumed = false;
			  trackobj.dd_url = handleMsgData.ddUrl;
			  me.trackLessonInICEPIE(trackobj, "lesson_element_started");				  
		  }
		  else if(handleMsgData.action == "activityClicked") {
			 trackobj.interactivity_id = handleMsgData.type.toLowerCase() == "act" ? null : me.pulseInteractivityId;
			 if(me.icepieActivityTrackingTimer) {
				 me.trackICEPIEACTIVITYLessonUser();
				 me.icepieActivityTrackingTimer = false;
				 me.icepieTrackingTimer = false;
			 }
			 
		  }
		  
		  
		   me.previousEventObj = handleMsgData;
		  
	  }
	  
	   
    }
	trackLessonPause(trackobj) {
	    this.icepieTrackingTimer = false;
	    this.trackLessonInICEPIE(trackobj, "lesson_element_paused");		
	}
	trackLessonInICEPIE(trackobj,actionString){		
		try{			
			this.initiateTrack(actionString,trackobj);
		}catch(e){
		}
	}
	setLessonNameAsTitle(lessonId){
		try{
			if(lessonId){
				var title = UserStorageUtil.getStoredSessionItem(lessonId);

				if(!title){
					title = sessionStorage.getItem(lessonId);
				}else{
					title = " " + title + " ";

					if(sessionStorage){
						if(!sessionStorage.getItem(lessonId))
							sessionStorage.setItem(lessonId, title);

						//remove after setting
						UserStorageUtil.deleteSessionItem(lessonId);
					}							
				}

			}


			if(title)
				document.title += title;	
		}catch(e){}
	}
	trackICEPIELessonUser(){
		try{
			var params = this.getAllParamsObj();
			var trackObj = {
				"lesson_id": parseInt(params.lessonidTracking),
			    "lesson_dd": this.currentDD,
			    "type": this.getTracker().enums.lessonElementType["video"],
			    "interactivity_id": null
			}

			this.initiateTrack("lesson_element_pulsed",trackObj);
		}catch(e){
		}
	}
	trackICEPIEACTIVITYLessonUser(){
		
		try{
			var params = this.getAllParamsObj();
			var trackObj = {
				"lesson_id": parseInt(params.lessonidTracking),
			    "lesson_dd": this.currentDD,
			    "type": this.interativeType,
			    "interactivity_id": this.pulseInteractivityId
			}

			this.initiateTrack("lesson_element_pulsed",trackObj);
		}catch(e){
		}
	}
	
	initiateICEPIEActivityTimer(){		
		var me = this;
		setInterval(() => {
			//if(me.icepieActivityTrackingTimer){	   
	   	 		me.icepieActivityTrackingTimer = true;
	   	 	//}
   	 }, 10000);
	}
	initiateICEPIETimer(){		
		var me = this;
		setInterval(() => {
			if(me.icepieTrackingTimer){	   	 		
	   	 		me.trackICEPIELessonUser();
	   	 	}
   	 }, 10000);
	}
	initiateTimer(){
		var me = this;
		setInterval(() => {
				if(me.enableTimer){
	   	 		//console.log("initiateTimer ::");
	   	 		me.trackLessonClose();
	   	 	}
	   	 }, 5000);
	}
	initiateSessionTimer(){
		var me = this;
		setInterval(() => {
			if(me.enableSessionTimer){
	   	 		me.SessionCheck();
	   	 		me.enableSessionTimer = false;
	   	 	}
	   	 }, 60000);
	}
	
	getAdditionalUrlParams(lessonUrl){
		try{
			var paramsArr = window.location.href.split("?");
			if(paramsArr.length > 1 && paramsArr[1].length > 0){
				lessonUrl += "&"+paramsArr[1];

				var paramObj = this.extractParamsObj(paramsArr[1]);

				this.setLessonNameAsTitle(paramObj["url"]);
			   //If it is a new window, else do not change the title
			 /*  if(paramObj["lessonname"] !== undefined && paramObj["lessonname"] !== null && paramObj["lessonname"].length > 0){
			   		try{document.title += " " + decodeURIComponent(paramObj["lessonname"]) + " ";}catch(e){}
			   	}*/

			   }
			}catch(e){}

			return lessonUrl;
		}
		getAllParamsObj(){
			var paramObj = {};
			try{
				var paramsArr = window.location.href.split("?");
				if(paramsArr.length > 1 && paramsArr[1].length > 0){
					paramObj = this.extractParamsObj(paramsArr[1]);			   
				}
			}catch(e){}

			return paramObj;
		}
		getAllUrlParams(urlString){
			try{
				var paramsArr = window.location.href.split("?");
				if(paramsArr.length > 1 && paramsArr[1].length > 0){
					if(urlString.indexOf("?") > 0){
						urlString += "&"+paramsArr[1];
					}else{
						urlString += "?"+paramsArr[1];
					}
				}
			}catch(e){}

			return urlString;
		}

		extractParamsObj(paramsArrStr){
			var paramObj = {};
			try{
				if(paramsArrStr !== null && paramsArrStr.length > 0){
					var paramPairArr = paramsArrStr.split("&");
					if(paramPairArr !== null && paramPairArr.length > 0){
						for(var i=0; i < paramPairArr.length; i++){
							var eachPair = paramPairArr[i].split("=");
							paramObj[eachPair[0]] = (eachPair.length > 0) ? eachPair[1] : eachPair[0];
						}
					}
				}
			}catch(e){}

			return paramObj;
		}

		getLessonUrl(){
			try{
				var me = this;

				var successHandler = function (data) {
					if ((data === null) || (data !== null && data.errorMsg)) {
						var buttons = [{
							label: me.rb("home.btn.close"),
							handler: () => { window.close(); }
						}]
						
						if(data.errorMsg && data.errorMsg === "mobile_no_flash"){
							me.errorMsg={
								heading:me.rb("lesson."+data.errorMsg+".heading") || me.rb("lesson."+data.errorMsg+".heading"),
								srcval:"desktoporlaptop",
								description:me.rb("lesson."+data.errorMsg) || me.rb("lesson."+data.errorMsg)
							}
							me.setState({AlertModalShow:true});
						}
						
						else if(data.errorMsg && data.errorMsg === "not_authorized"){
							me.showAlert(null, me.rb("lesson."+data.errorMsg) || me.rb("lesson."+data.errorMsg), buttons);
						}
						
						else if(data.errorMsg && data.errorMsg === "user_session_not_available"){
							me.showAlert(null, me.rb("lesson."+data.errorMsg) || me.rb("lesson."+data.errorMsg), buttons);
						}
						
						else if(data.errorMsg && data.errorMsg === "no_lesson_id"){
							me.showAlert(null, "<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>", buttons);
						}
						
						else if(data.errorMsg && data.errorMsg === "not_free_lesson"){
							me.showAlert(null, "<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>",'',"no");
						}
						
						else if(data.testStatus){
							me.showAlert(me.rb(data.testStatus), me.rb(data.reference_id) || me.rb(data.testStatus), buttons);
						}
						else{
							me.showAlert(null, me.rb(data.errorMsg) || me.rb("lesson."+data.errorMsg), buttons);
						}
						
						return;
					}

					if(data && data.lessonUrl){
						me.setState({ "dataLoaded": true, "data": data, lessonUrl:me.getAdditionalUrlParams(data.lessonUrl)});
						
						me.trackLessonOpen();
						me.initiateTimer();
						
						setTimeout(function()
			        	{		        		
			        		me.setContentSize();
			        	},1500);
					}else{
						//Please close this window and login to continue
					}
				}

				var failureHandler = function (err) {
					var buttons = [{
						label: me.rb("go_home"),
						handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
					}]
					me.showAlert(me.rb("error"), me.rb("generic_connect_error"), buttons);

					return;
				}
				var lessonId = this.props.match.params.id;

				new HmAjax(this.getAllUrlParams(this.getUrlFor("LESSON_URL")+lessonId)).get(successHandler,failureHandler);
			}catch(e){
				var buttons = [{
					label: me.rb("go_home"),
					handler: () => {window.location.href = me.getUrlFor("LOGIN_HOME");}
				}]
				me.showAlert(me.rb("error"), me.rb("system_error"), buttons);
			}

		}
		trackLessonClose(){
			try{
				var me = this;

				var successHandler = function (data) {
					console.log("track lesson close success");
				}

				var failureHandler = function (err) {
					console.log("Error in TRACK_LESSON_CLOSE");
					return;
				}
				new HmAjax(this.getUrlFor("TRACK_LESSON_CLOSE")+me.trackId+"/"+me.userId).get(successHandler,failureHandler);
			}catch(e){
				console.log("Error in track lessson close..");
			}
		}
		trackLessonCloseInICEPIE(){
			try{
				var params = this.getAllParamsObj();
				var trackObj = {
					"lesson_id": parseInt(params.lessonidTracking)				     
				}

				this.initiateTrack("lesson_closed",trackObj);
			}catch(e){
			}
		}
		trackLessonOpen(){
			var params = this.getAllParamsObj();
		/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/		
		var formData = {
			"lessonUrl" : params.url, 
			"lessonDd" : (params.lessonPref == "flash") ? 0 : (parseInt(params.dd) || 1), 
			"lessonType" : params.lessonPref, 
			"classId" : parseInt(params.classId), 
			"accessId" : parseInt(params.accessId), 
			"topicSubtopicMapId" : parseInt(params.revisiontopicid),
			"lessonSrc":!isNaN(params.lessonSrc) ? Number(params.lessonSrc) : 1
		}
		
		try{
			var me = this;
			var successHandler = function (data) {
				if (data != null) {
					me.trackId = data.trackId;
					return;
				}

			}

			var failureHandler = function (err) {
				console.log("Error in TRACK_LESSON_OPEN");
				return;
			}
			var lessonId = this.props.match.params.id;

			new HmAjax(this.getUrlFor("TRACK_LESSON_OPEN"),formData).post(successHandler,failureHandler);
		}catch(e){
			console.log("Error in lesson tracking...");
		}
		
		try{
			var trackObj = {
				"lesson_id": parseInt(params.lessonidTracking),
				"lesson_dd": parseInt(params.dd) || 1,
				"source": this.getTracker().enums.lessonSource[params.tracksource],
				"source_id": parseInt(params[params.tracksource == "subtopic" ? "revisiontopicid" : "testid"]),
				"snippet_id": parseInt(params.snid) || 0,
				"question_source": params.qsrc || 0
			}
			
			this.initiateTrack("lesson_opened",trackObj);
		}catch(e){
		}
	}
	setContentSize()
	{
		var me = this;
		//
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      		//
      		$("#contentIFrame").css("visibility","hidden");
        	setTimeout(function()
        	{
        		$("#contentIFrame").css("visibility","visible");
        		me.resizeCall();
        	},1000);
        	//
    	}
		me.resizeCall();
	}
	//
	resizeCall()
	{
		
		//
		try
		{
			$("#contentIFrame").css({
				width:window.innerWidth,
				height:window.innerHeight
			});
		}catch(e)
		{
		}
	}
	hideAlertModal(){
		this.setState({AlertModalShow:false});
		window.close();
	}

	renderModalContent(){
		return(
			<div>							
					<TestTakingModalComponent visible={this.state.AlertModalShow} dialogClassName={"loginModal modal-lg"}>						
					<div className="modal-header bg-purple">
					<div className="modal-title">
					
					</div>
					<div className="close helpClose"  onClick={this.hideAlertModal} aria-label="Close">
					          <span aria-hidden="true"><i className="material-icons">close</i></span>
					        </div>
					</div>
						<div className="modal-body" className="col-12 text-center bdycont">
							<Errmsg errormsg={this.errorMsg}></Errmsg>
						</div>							
					</TestTakingModalComponent>

					
				</div>
		);
	}
	render() {	
		const me = this;
		if(!this.state.dataLoaded || this.state.lessonUrl === null){
			return (<div> 
				{this.showLoader()}
				
				{this.renderModalContent()}
				
			</div>);
		}else{
			if(this.state.lessonUrl){
					return (  
					<div id="lessonIframeContainer" style={{height:"100vh", overflowY:'hidden'}}>
						<iframe 
						id="contentIFrame"
						style={{width:'100%', height:me.state.iFrameHeight, overflowY:'hidden'}}
						onLoad={() => {
							me.setContentSize();
							me.setState({
								"iFrameHeight":  (window.innerHeight) + 'px'
							});
						}} 
						ref="iframe" 
						src={me.substituteZAProxy()}
						width="100%" 
						height={me.state.iFrameHeight} 
						scrolling="no" 
						frameBorder="0"
						referrerpolicy="no-referrer-when-downgrade"	
						/>
							
						{this.renderModalContent()}		
					</div>
					);	
			}
			
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/lesson/LessonView.js